import { SimpleSpinner } from '@components/Loading/SimpleSpinner';
import { Toast } from '@components/Toast';
import { device } from '@constants/mediaQueries';
import { salesBomPartsMatching } from '@constants/URLs';
import { faFileSpreadsheet } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled, useMediaQuery } from '@mui/material';
import MUITypography from '@mui/material/Typography';
import { LearnMoreSBOMButton } from '@pages/CreateNewProductPage/SalesBOMPage/LearnMoreSBOMButton';
import { useDownloadSBOM } from '@pages/CreateNewProductPage/SalesBOMPage/useDownloadSBOM';
import { DownloadTemplateButton } from '@pages/CreateNewProductPage/styles';
import { useTenant } from '@providers/Tenant';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

export function DownloadSalesBOM() {
  const location = useLocation();
  const { t } = useTranslation('createProduct');
  const isMobile = useMediaQuery(device.mobileOrTablet);
  const searchParams = new URLSearchParams(location?.search);
  const { accountId } = useTenant();
  const configurationPID = searchParams.get('configurationPID');
  const productName = searchParams.get('productName');
  const { isLoading, isError, handleClick } = useDownloadSBOM(accountId, configurationPID!, productName!);

  return (
    <>
      <DownloadSectionContainer>
        <DescriptionText>{t('useTemplate')}</DescriptionText>
        <DownloadTemplateButton
          variant="contained"
          size={isMobile ? /* istanbul ignore next */ 'medium' : 'large'}
          startIcon={
            isLoading ? /* istanbul ignore next */ null : <FontAwesomeIcon icon={faFileSpreadsheet} size="3x" />
          }
          type="button"
          data-testid="download-template-button"
          onClick={handleClick}
          disabled={isLoading}
        >
          {isLoading ? /* istanbul ignore next */ <SimpleSpinner /> : t('downloadTemplate')}
        </DownloadTemplateButton>
        {/* Temporary link */}
        <LearnMoreSBOMButton href={salesBomPartsMatching} />
      </DownloadSectionContainer>
      <Toast
        dependency={isError}
        severity="error"
        title={`${t('errorDownloadingTemplate')}`}
        message={`${t('errorDownloadingTemplateMessage')}`}
        data-testid="toast-notification"
      />
    </>
  );
}

const DownloadSectionContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-top: ${({ theme }) => theme.spacing(1)};
`;

const DescriptionText = styled(MUITypography)`
  @media only screen and ${device.mobileOrTablet} {
    font-size: ${({ theme }) => theme.typography.body2.fontSize};
  }
`;
